import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ component: Component }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/onboarding/signup" />;
  }

  return <Component />;
};

export default ProtectedRoute;
